import styled from '@emotion/styled';
import { LoadingPrimary, Tooltip } from '@sharefiledev/flow-web';
import { Flex } from 'antd';

const documentTitleHeight = 72;
export const paddingTop = 20; // Padding top for the PDF Pages

export const StyledDocumentsPanel = styled.div`
	height: calc(100vh - 120px);
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0px;
	width: 20%;
	min-width: 280px;
	max-width: 320px;
	overflow-y: hidden;
`;

export const NavigationPanel = styled.div<{ showPanel: boolean }>`
	position: relative;
	height: 100%;
	width: 100%;
	display: ${({ showPanel }) => (showPanel ? 'block' : 'none')};
`;

export const DocumentTitle = styled.div`
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
	padding: 24px;
	gap: 8px;
	width: 100%;
	min-width: 256px;
	max-width: 320px;
	height: ${documentTitleHeight}px;
	background: #ffffff;
	border-bottom: 1px solid #d9d9d9;
	white-space: nowrap; /* Prevent text from wrapping */
	overflow: hidden; /* Hide overflowing text */
	text-overflow: ellipsis; /* Display an ellipsis (...) for overflowed text */
`;

export const FileNameTooltip = styled(Tooltip)`
	display: block;
	overflow-x: hidden;
`;

export const FileName = styled.p`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	font-size: 16px;
	color: #171717;
	font-weight: 600;
`;

export const DocumentPanelLoadingPrimary = styled(LoadingPrimary)`
	position: absolute;
	top: 0%;
`;

export const DocumentPanelLoader = styled(Flex)<{ height: number }>`
	height: ${props => props.height - documentTitleHeight - paddingTop}px;
`;
